/**
 * Adds headers to the `XMLHttpRequest` object.
 *
 * @param {XMLHttpRequest} xhr: the XMLHttpRequest object
 * @param {Object} headers: an object with the headers to set
 */
export default function setRequestHeaders(xhr, headers) {
  for (const key in headers) {
    xhr.setRequestHeader(key, headers[key]);
  }
}
